import React from 'react'
import { makeStyles, TextField } from '@material-ui/core'
import Button from './button'

const useStyles = makeStyles({
    root: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 12
    },
    stepBtn: {
        '&&': {
            width: 40,
            height: 40,
            minWidth: 0,
            padding: 0,
            borderRadius: 999,
            fontSize: 22,
            lineHeight: 1
        }
    }
})

function NumberStepperInput({
    value,
    setValue,
    onStep,
    onInvalidChange,
    pattern = /^\d+$/,
    isError,
    onBlur,
    size,
    className,
    inputProps,
    decrementDisabled,
    decrementLabel,
    incrementLabel
}) {
    const classes = useStyles()

    const handleChange = e => {
        const raw = e.target.value
        if (raw === '' || pattern.test(raw)) {
            if (setValue) setValue(raw)
            return
        }
        e.target.value = value ?? ''
        if (onInvalidChange) onInvalidChange(raw)
    }

    return (
        <div className={classes.root}>
            <Button
                reverted
                aria-label={decrementLabel}
                className={classes.stepBtn}
                disabled={decrementDisabled}
                onClick={() => onStep(-1)}>
                −
            </Button>
            <TextField
                variant="outlined"
                size={size}
                type="text"
                value={value ?? ''}
                onChange={handleChange}
                onBlur={onBlur}
                error={isError}
                className={className}
                inputProps={{
                    inputMode: 'numeric',
                    pattern: '[0-9]*',
                    ...inputProps
                }}
                InputProps={{ style: { borderRadius: 7 } }}
            />
            <Button
                reverted
                aria-label={incrementLabel}
                className={classes.stepBtn}
                onClick={() => onStep(1)}>
                +
            </Button>
        </div>
    )
}

export default NumberStepperInput
